import { gql } from '@apollo/client';
import { articlesWithoutUserRelationsQueryFragment } from '../../TerritoryArticlesSection/queries/articlesQueryFragment';
import { ARTICLE_CARD_FIELDS } from '../../TerritoryArticlesSection/queries/articleCardDataFragment';

export const getPromptArticlesQuery = gql`
    ${ARTICLE_CARD_FIELDS}
    query promptArticles($promptId: ID!, $type: ArticleTypeType, $skip: Int, $take: Int) {
      article(where: { id: $promptId }) {
        id
        title
        slug
        territory {
          id
          name
          slug
          territoryImage {
            ...BaseImageFields
          }
        }
        coverImage {
          ...BaseImageFields
        }
        childArticlesCount(where: { status: { equals: "published" }, type: { equals: ARTICLE }, deactivated: { equals: false } })
       ${articlesWithoutUserRelationsQueryFragment('childArticles')}
      }
  }
`;
